import * as t from 'io-ts';
import { isLeft } from 'fp-ts/Either';

import { SimpleReporter } from './reporter';

class ValidationError<T extends t.Validation<unknown>> extends Error {
  result: T;
  readonly name: string;

  constructor(result: T) {
    super('Validation Error');
    this.result = result;
    this.name = 'ApiValidationError';
  }

  static is(x: any): x is ValidationError<any> {
    return this.name === 'ApiValidationError';
  }
}

const validate = <Output, Input>(
  type: t.Decoder<Input, Output>,
  raw: Input,
  errorSource?: string,
): Output => {
  const result = type.decode(raw);

  if (isLeft(result)) {
    // eslint-disable-next-line no-console
    console.error(
      `Could not validate data for ${errorSource}:\n${SimpleReporter.report(result).join('\n')}`,
    );

    throw new ValidationError(result);
  }

  return result.right;
};

export { validate, ValidationError };
